import React from 'react';
import { Link } from 'react-router-dom';
import { formatTestId } from '../../util/EfupUtility';

const nbsp = '\u00A0';

export default function Tile(props) {
    
    const {title, link, children:body } = props;
    const titleTestId = formatTestId(`tile-${title}`)
    const bodyTestId = `${titleTestId}-body`
    const footerTestId = `${titleTestId}-footer`

    let {footer, isLoading} = props;

    if (link && !footer) {
        footer = "View";
    }
    
    
    return (
        <div className={props.className ? props.className : 'dashCard'}>
            <p className="title" data-testid={titleTestId}>{title}</p>
            <div className="body" data-testid={bodyTestId}>{body || nbsp}</div>
            <p className="footer" data-testid={footerTestId}>
                {footer && 
                 link && link.path ? <Link className={isLoading ? 'tile-link disabled' : 'tile-link'} data-testid={`${footerTestId}-link`} to={link.path} state={link.state ? link.state : {} }>{footer}</Link> : <>{footer}</>
                }
            </p>
        </div>
    );
};
